import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86a08ad0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "question-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Bedrijfsgegevens invoeren", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "question-checkbox-list"
}
const _hoisted_5 = ["id", "checked", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "icon-chevron-right" }, null, -1))
const _hoisted_9 = { class: "button-bar" }
const _hoisted_10 = ["disabled"]

import {computed, onMounted, ref, Ref} from 'vue';
	import CheckPageTemplate from '@/components/check/CheckPageTemplate.vue';
	import {pageHelper} from '@/utils/pageHelper';
	import {ICompanyChecks} from '@/types/ICompanyChecks';
	import {checkStoreMethod} from '@/store/check/checkStore';
	import {Api} from '@/utils/api';
	import NumberUtils from '@/utils/numberUtils';
	import {checkHelper} from '@/utils/checkHelper';
	import {useRoute, useRouter} from 'vue-router';
	import {useStore} from 'vuex';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'PageCheckStart',
  setup(__props) {

	const route = useRoute();
	const store = useStore();
	const router = useRouter();

	const loading: Ref<boolean> = ref(true);

	const companies: Ref<Array<ICompanyChecks>> = ref([]);

	const selectedCompany: Ref<ICompanyChecks | undefined> = ref(undefined);

	const selectedCompanyId = computed(() => selectedCompany.value?.id);

	const checkToStart = computed(() => checkHelper.getChecksArray().find(check => check.enum === route.query.check));

	const checkToStartTitle = computed(() => checkToStart.value?.title);

	const allowedCompanies = computed(() => companies.value.filter(company => company.permission.hasWriteAccess)
		.filter(company => company.checks.find(check => check.check === checkToStart.value?.enum))
		.sort((a, b) => a.name.localeCompare(b.name)));

	const handleChange = (event: Event) => {
		const target = event.target as HTMLInputElement;
		if (target.checked) {
			const value = NumberUtils.stringToNumber(target.value);
			selectedCompany.value = companies.value.find(company => company.id === value);
		}
	};

	const handleSubmit = async () => {
		if (!selectedCompany.value) {
			return;
		}

		const companyCheck = selectedCompany.value.checks.find(check => check.check === checkToStart.value?.enum);

		if (!companyCheck) {
			return;
		}

		const companyId = selectedCompany.value.id;

		if (companyCheck.started) {
			await router.push(companyCheck.checkUrl);
		} else {
			await checkHelper.startCheck(companyId, companyCheck.check)
				.then(() => router.push(companyCheck.checkUrl))
				.catch(() => store.dispatch(checkStoreMethod.SET_ERROR, 'De verbetercheck kan niet gestart worden.'));
		}
	};

	const loadCompanies = async () => {
		loading.value = true;

		await Api.getCompanies()
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			.then(async (response: any) => {
				companies.value = response.responseObject;
				await store.dispatch('updateCompanyList', response.responseObject);
			})
			.catch(() => store.dispatch(checkStoreMethod.SET_ERROR, 'Bedrijven kunnen niet worden opgehaald.'))
			.finally(() => loading.value = false);
	};

	onMounted(async () => {
		if (store.getters.userHasRoleCoach()) {
			await router.replace({name: pageHelper.PAGE_MY_COMPANIES});
		} else {
			await loadCompanies();
		}
	});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(CheckPageTemplate, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h1", null, "Voor welk bedrijf wil je de verbetercheck " + _toDisplayString(checkToStartTitle.value) + " uitvoeren?", 1),
        _createElementVNode("p", null, " Je kunt de verbetercheck " + _toDisplayString(checkToStartTitle.value) + " starten voor een eigen bedrijf of een bedrijf waarvoor je bent uitgenodigd om aan mee te werken of te administreren. ", 1),
        (loading.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Bedrijven worden geladen..."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (allowedCompanies.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedCompanies.value, (company) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: company.id,
                        class: "question-checkbox-list-item"
                      }, [
                        _createElementVNode("input", {
                          id: company.id,
                          checked: company.id === selectedCompanyId.value,
                          value: company.id,
                          type: "radio",
                          onChange: handleChange
                        }, null, 40, _hoisted_5),
                        _createElementVNode("label", {
                          for: company.id
                        }, _toDisplayString(company.name), 9, _hoisted_6)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_7, [
                    _createElementVNode("strong", null, " Je hebt geen bedrijven waarvoor je de verbetercheck " + _toDisplayString(checkToStartTitle.value) + " kunt starten. ", 1)
                  ])),
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, {
                  to: { name: _unref(pageHelper).PAGE_ADD_COMPANY},
                  class: "create-company-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createTextVNode(" Maak een nieuw bedrijf aan ")
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: _normalizeClass([{'disabled': !selectedCompany.value}, "button-blue"]),
                  disabled: !selectedCompany.value,
                  type: "button",
                  onClick: handleSubmit
                }, " Ok, verder ", 10, _hoisted_10),
                _createElementVNode("button", {
                  class: "button-no-border",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
                }, " Vorige ")
              ])
            ], 64))
      ])
    ]),
    _: 1
  }))
}
}

})